import Vue from 'vue';
import VueApollo from 'vue-apollo';
import { ApolloClient } from 'apollo-client';
import { createHttpLink } from 'apollo-link-http';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { env } from '@/utils/env';
import { typeDefs } from './typeDefs';

const httpLink = createHttpLink({
  uri: env.VUE_APP_API_URL || 'http://localhost:4002/query',
  headers: {
    'Cache-Control': 'no-cache',
  },
});

const cache = new InMemoryCache();

export const apolloClient = new ApolloClient({
  link: httpLink,
  cache,
  typeDefs,
  resolvers: {},
  defaultOptions: {
    query: {
      // fetchPolicy: 'network-only',
      fetchPolicy: 'no-cache',
    },
  },
});

Vue.use(VueApollo);

const errorHandler = error => {
  console.log( // eslint-disable-line
    '%cError',
    'background: red; color: white; padding: 2px 4px; border-radius: 3px; font-weight: bold;',
    error.message
  );
};


export const createProvider = () => new VueApollo({
  defaultClient: apolloClient,
  errorHandler,
});
